import React from 'react';
import Hero from '../../hero/Hero';
import nikeLogo from '../../images/sponsor-logo/nike-sponsor.png';
import adidasLogo from '../../images/sponsor-logo/adidas-sponsor.png';
import underArmourLogo from '../../images/sponsor-logo/under-armour-sponsor.png';
import './our-mission.css';

const OurMission = () => {
	return (
		<React.Fragment>
			<Hero>
				<div className="background-img-our-mission">
					<h1 className="our-mission-typography">Our Mission</h1>
				</div>
			</Hero>
			<div className="about-us-container">
				<div className="about-section-container">
					<div>
						<h1 className="about-us-typography">About Us</h1>
						<div className="about-section">
							<p>
								StayFit is more than just a gym. We take fitness to a whole new level by ensuring every
								member achieves their goals and live a healthy lifestyle. At StayFit we provide free
								training for all members and give access to extracurricular activities around the gym.
							</p>
						</div>
					</div>
					<div className="sponsorship-container">
						<h1 className="sponsorship-typography">Sponsors</h1>
						<ul className="sponsor-list">
							<div className="sponsor-items-container">
								<li>
									<img src={nikeLogo} alt="nike-logo" className="sponsor-logo" />
								</li>
							</div>
							<div className="sponsor-items-container">
								<li>
									<img src={adidasLogo} alt="adidas-logo" className="sponsor-logo" />
								</li>
							</div>
							<div className="sponsor-items-container">
								<li>
									<img src={underArmourLogo} alt="under-armour-logo" className="sponsor-logo" />
								</li>
							</div>
						</ul>
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default OurMission;
